const URL = {
	INDEX: '',
	HOME: '/:partner',
	ABOUT: '/about',
	CONTACT: '/contact',
	PAYMENT: '/payment',
	PAYMENT_SUCCESS: '/paymentsuccess',
	PAYMENT_FAIL: '/paymentfails',
	RECOVER_TICKET: '/recoverTicket',
	THANKYOU: '/download',
	SIGNUP: '/signup',
	FORFOT_PASSWORD: '/reset-password/:token_id',
	SEND_EMAIL_FORGOT_PASSWORD: '/send-email',
	PASS: '/pass',
	PASSCREATE: '/pass-create',
	USER: '/user',
	USER_PROFILE: '/user-profile',
	PASS_PAYMENT_SUCCESS: '/userpass-after-payment',
	PASS_PAYMENT_FAIL: '/userpass-payment-failed',
	NAVIGATING: '/navigating/:acc/:ref',
	NAVIGATING_RECEIPT: '/navigating/:acc/:ref/:isreceipt',
	NAVIGATING_PARTNER: '/navigating/:acc/:ref/:isreceipt/:secret',
	NAVIGATING_MASQUERADE_PARTNER: '/navigating/:acc/:ref/:isreceipt/:masquerade/:secret',
	BOOKTICKET: '/booking',
	CHECKOUT_PASSES: '/booking/checkout-passes',
	AAA_PAYMENT_RESPONSE: '/booking/paymentResponse',
	AAA_PAYMENT_FAILED: '/booking/paymentFailed',
	AAA_PAYMENT_SUCCESS: '/booking/payment-success',
	AAA_FAILED_COMPONENT: '/booking/payment-failure',
	AAA_BOOKING_RESPONSE: '/booking/booking-response',
	TICKET: '/ticket/:ticketId',
	TICKET_VIEW: '/ticket',
	RESPONSIVE_RESERVATION: '/book-reservation',

	// BASE_HOME: '',
	// BASE_ABOUT: '/about',
	// BASE_CONTACT: '/contact',
	// BASE_PAYMENT: '/payment',
	// BASE_PAYMENT_SUCCESS: '/paymentsuccess',
	// BASE_PAYMENT_FAIL: '/paymentfails',
	// BASE_RECOVER_TICKET: '/recoverTicket',
	// BASE_THANKYOU: '/download',
	// BASE_SIGNUP: '/signup',
	// BASE_FORFOT_PASSWORD: '/reset-password/:token_id',
	// BASE_SEND_EMAIL_FORGOT_PASSWORD: '/send-email',
	// BASE_PASS: '/pass',
	// BASE_PASSCREATE: '/pass-create',
	// BASE_USER: '/user',
	// BASE_USER_PROFILE: '/user-profile',
	// BASE_PASS_PAYMENT_SUCCESS: '/userpass-after-payment',
	// BASE_PASS_PAYMENT_FAIL: '/userpass-payment-failed',
	// BASE_NAVIGATING: '/navigating/:acc/:ref',
	// BASE_NAVIGATING_RECEIPT: '/navigating/:acc/:ref/:isreceipt',
	// BASE_NAVIGATING_PARTNER: '/navigating/:acc/:ref/:isreceipt/:secret',
	// BASE_BOOKTICKET: '/booking',
	// BASE_CHECKOUT_PASSES: '/booking/checkout-passes',
	// BASE_AAA_PAYMENT_RESPONSE: '/booking/paymentResponse',
	// BASE_AAA_PAYMENT_FAILED: '/booking/paymentFailed',
	// BASE_AAA_PAYMENT_SUCCESS: '/booking/payment-success',
	// BASE_AAA_FAILED_COMPONENT: '/booking/payment-failure',
	// BASE_AAA_BOOKING_RESPONSE: '/booking/booking-response',
	// BASE_TICKET: '/ticket/:ticketId',
	// BASE_TICKET_VIEW: '/ticket',
	// BASE_RESPONSIVE_RESERVATION: '/book-reservation',

	EXTERNAL: 'https://www.npmjs.com/package/qrcode.react',
	PARKENGAGE_LOGO_URL: 'https://parkengage.com/static/media/logo.8ed76367.svg',
	RESERVATION: 'https://demo-reservation.parkengage.com/',
}

export default URL
